import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import ProfileTeacher from "./views/ProfileTeacher.vue";
import MainPage from "./views/Main.vue"; // Import the new MainPage component
import Lesson from "./views/Lesson.vue";
import Lessons from "./views/Lessons.vue";
import UserLessons from "./views/UserLessons.vue";
import LessonEdit from './views/LessonEdit.vue';
import SubLessons from './views/SubLessons.vue';
import UsersList from './views/UsersList.vue';
import Payment from "./views/Payment.vue";
import LessonSubscriptions from "./views/LessonSubscriptions.vue";
import LessonTypes from "./views/LessonTypes.vue";
import ResetPassword from "./views/ResetPassword.vue";
import CatalogeList from "./views/CatalogeList.vue";
import Catalog from "./views/CatalogeUpdate.vue";
import ProgramIcons from "./views/ProgramIcons.vue";
import Coupons from "./views/Coupons.vue";
import Policy from "./views/Policy.vue";
import Terms from "./views/Terms.vue";

Vue.use(Router);

const requireAuth = async (to, from, next) => {
  const store = require("@/stores").default; // Import Vuex store
  try {
    const isAuthenticated = await store.dispatch("auth/checkAuth");
    if (isAuthenticated) {
      next();
    } else {
      next({ name: "login" });
    }
  } catch (error) {
    console.error("Auth check failed:", error);
    next({ name: "login" });
  }
};

const requireGuest = async (to, from, next) => {
  const store = require("@/stores").default;
  try {
    const isAuthenticated = await store.dispatch("auth/checkAuth");
    if (isAuthenticated) {
      next({ name: "Main" }); // Redirect logged-in users to home
    } else {
      next();
    }
  } catch (error) {
    console.error("Auth check failed:", error);
    next();
  }
};

const requireAuthAdmin = async (to, from, next) => {
  const store = require("@/stores").default;
  try {
    const isAuthenticated = await store.dispatch("auth/checkAuth");
    // Check if the authenticated user has admin privileges (user_type === 3).
    const user = store.getters["auth/getUser"];
    if (isAuthenticated && user && user.user_type === 3) {
      next();
    } else {
      next({ name: "Main" });
    }
  } catch (error) {
    console.error("Admin auth check failed:", error);
    next({ name: "Main" });
  }
};

export default new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "Main",
      components: {
        header: AppHeader,
        default: MainPage, // Use the new MainPage component
        footer: AppFooter
      }
    },
    {
      path: "/policy",
      name: "policy",
      components: {
        header: AppHeader,
        default: Policy,
        footer: AppFooter
      }
    },
    {
      path:"/terms",
      name: "terms",
      components: {
        header: AppHeader,
        default: Terms,
        footer: AppFooter
      }
    },
    {
      path: "/Lessons",
      name: "Lessons",
      components: {
        header: AppHeader,
        default: Lessons,
        footer: AppFooter
      }
    },
    {
      path: "/userlessonlist",
      name: "UserLessonList",
      components: {
        header: AppHeader,
        default: UserLessons,
        footer: AppFooter
      },
      beforeEnter: requireAuth // Protect this route
    },
    {
      path: "/catalog/:id",
      name: "catalog",
      components: {
        header: AppHeader,
        default: Catalog,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin // Protect this route
    },
    {
      path: "/cataloglist",
      name: "CatalogList",
      components: {
        header: AppHeader,
        default: CatalogeList,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin // Protect this route
    },
    {
      path: "/programicons",
      name: "ProgramIcons",
      components: {
        header: AppHeader,
        default: ProgramIcons,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin // Protect this route
    },
    {
      path: "/coupons",
      name: "Coupons",
      components: {
        header: AppHeader,
        default: Coupons,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin // Protect this route
    },
    {
      path: "/lessontypes",
      name: "LessonTypes",
      components: {
        header: AppHeader,
        default: LessonTypes,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin
    },
    {
      path: "/sublessonlist",
      name: "SubLessonsList",
      components: {
        header: AppHeader,
        default: SubLessons,
        footer: AppFooter
      }
    },
    {
      path: "/Lesson/view/:id",
      name: "Lesson",
      components: {
        header: AppHeader,
        default: Lesson,
        footer: AppFooter
      }
    },
    {
      path: "/Lesson/edit/:id",
      name: "LessonEdit",
      components: {
        header: AppHeader,
        default: LessonEdit,
        footer: AppFooter
      },
      beforeEnter: requireAuth // Protect this route
    },
    {
      path: "/LessonSubscriptions",
      name: "LessonSubscriptions",
      components: {
        header: AppHeader,
        default: LessonSubscriptions,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin
    },
    {
      path: "/pay/:id",
      name: "LessonPay",
      component: Payment,
      beforeEnter: requireAuth
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      },
      beforeEnter: requireGuest
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      },
      beforeEnter: requireGuest
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      },
      beforeEnter: requireAuth // Protect this route
    },
    {
      path: "/teacher/:id",
      name: "teacherview",
      components: {
        header: AppHeader,
        default: ProfileTeacher,
        footer: AppFooter
      }
    },
    {
      path: "/reset-password",
      name: "resetpassword",
      components: {
        header: AppHeader,
        default: ResetPassword,
        footer: AppFooter
      },
      beforeEnter: requireGuest
    },
    // Admin-only route example:
    {
      path: "/userslist",
      name: "UsersList",
      components: {
        header: AppHeader,
        default: UsersList,
        footer: AppFooter
      },
      beforeEnter: requireAuthAdmin // Only admin users (user_type === 3) can access this route
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
